// Отдельная точка входа: PHP откладывает виджеты только при наличии этой сборки.
import { installDeferredWidgets } from './widgets';
import { installDeferredImages } from './product-images';

// Ошибка запуска (например, в старом браузере) не должна оставить страницу без фото,
// CAPTCHA и карт: запасной путь из first-screen-fallback.js возвращает прежнюю разметку.
function guarded(install) {
    try {
        install(document);
    } catch (error) {
        if (typeof window.sdFirstScreenFallback === 'function') window.sdFirstScreenFallback();
        throw error;
    }
}

guarded(installDeferredImages);

function install() {
    guarded(installDeferredWidgets);
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install);
} else {
    install();
}
